import React, { useContext, useEffect } from 'react'

import { WithFullpage } from '../../app/providers/WithFullpage'
import { MainContext } from '../../app/providers/MainContext'
import { GitbookScreens } from '../../widgets/Screens/Gitbook'
import { ClaimScreens } from '../../widgets/Screens/Claim'

export const Claim = () => {
  const { setCurrentPage } = useContext(MainContext)

  useEffect(() => {
    setCurrentPage('claim')
  }, [])

  return (
    <>
      <WithFullpage
        fullpageOptions={{
          credits: {
            enabled: false,
          },
          scrollingSpeed: 1000,
          touchSensitivity: 10,
        }}
      >
        <>
          {ClaimScreens.map((screen, idx) => (
            <React.Fragment key={idx}>{screen}</React.Fragment>
          ))}
        </>
      </WithFullpage>
    </>
  )
}
